
import * as React from "react";
import { connect } from "react-redux";
import {  Drawer } from "../ecosystem";

const DrawerFindCare = ({
    children,
    open,
    toggle, 
}) => {
    return <>
        <Drawer
            title="Find Care"
            open={open}
            toggle={toggle}
        >
            <div className={"drawer-find-care-form"}>
                {children}
            </div>
        </Drawer>
    </>

}

export default DrawerFindCare;
